@if (kpiState$ | async; as kpi) {
  @if (kpi.isLoading) {
    <div class="h-[76px] w-full flex flex-col items-center justify-center">
      <nz-spin nzSimple nzSize="small"></nz-spin>
    </div>
  } @else {
    <div class="flex items-center gap-8">
      <div class="flex items-center flex-col mt-[10px] mr-8 gap-4">
        <svg width="36" height="40" viewBox="0 0 36 49" stroke-width="2.5" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="33.5275" y1="48.1636" x2="24.5275" y2="22.1636" stroke="currentColor" />
          <line x1="2.52956" y1="47.8306" x2="11.5296" y2="22.8306" stroke="currentColor" />
          <line x1="4.75193" y1="41.0636" x2="26.623" y2="28.5659" stroke="currentColor" />
          <line x1="30.7519" y1="40.4341" x2="9.75193" y2="28.4341" stroke="currentColor" />
          <line y1="22.5" x2="36" y2="22.5" stroke="currentColor" />
          <line x1="11.3166" y1="13.387" x2="0.316618" y2="22.387" stroke="currentColor" />
          <line x1="11.3166" y1="1.38698" x2="0.316618" y2="10.387" stroke="currentColor" />
          <line x1="24.3064" y1="13.6049" x2="35.6864" y2="22.4285" stroke="currentColor" />
          <line x1="24.3064" y1="1.60486" x2="35.6864" y2="10.4285" stroke="currentColor" />
          <line x1="11.5" x2="11.5" y2="22" stroke="currentColor" />
          <line x1="24.5" x2="24.5" y2="22" stroke="currentColor" />
          <line x1="12" y1="0.5" x2="24" y2="0.5" stroke="currentColor" />
          <line y1="10.5" x2="11" y2="10.5" stroke="currentColor" />
          <line x1="25" y1="10.5" x2="36" y2="10.5" stroke="currentColor" />
          <line x1="12.4341" y1="0.751931" x2="24.4341" y2="21.7519" stroke="currentColor" />
          <line x1="24.4305" y1="0.254365" x2="11.4305" y2="22.2544" stroke="currentColor" />
        </svg>

        <span class="text-sm text-gray-900">Grid</span>
      </div>

      <div class="flex items-center gap-4 flex-col mt-[-12px]">
        <span class="text-sm text-gray-900">{{ kpi.runningState }}</span>

        <svg viewBox="0 0 100 1" width="100%" height="8" aria-hidden="true" focusable="false" style="display: block">
          <line x1="0" y1="0.5" x2="100" y2="0.5" stroke="#1362fc" stroke-width="8" stroke-dasharray="4,2">
            @if (kpi.runningState === 'Charging') {
              <animate attributeName="stroke-dashoffset" values="6;0" dur="1s" repeatCount="indefinite" />
            } @else if (kpi.runningState === 'Discharging') {
              <animate attributeName="stroke-dashoffset" values="0;6" dur="1s" repeatCount="indefinite" />
            }
          </line>
        </svg>

        <span class="text-sm text-gray-900">{{ kpi.activePower }}</span>
      </div>

      <div class="flex items-center flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="url(#batteryFillGradient)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-battery-vertical"
        >
          <defs>
            <linearGradient id="batteryFillGradient" x1="0" y1="1" x2="0" y2="0">
              <stop [attr.offset]="0 + '%'" stop-color="#1362fc" />
              <stop [attr.offset]="kpi.socPercentage + '%'" stop-color="#1362fc" />
              <stop [attr.offset]="kpi.socPercentage + 1 + '%'" stop-color="white" />
              <stop [attr.offset]="100 + '%'" stop-color="white" />
            </linearGradient>
          </defs>
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2"
          />
        </svg>

        <span class="text-sm text-gray-900">{{ kpi.soc }}</span>
      </div>
    </div>
  }
}
